import { reducerGenerator, action, createSelector } from './utils';
import get from 'lodash.get';
import compareCardLocalstorage from 'service_modules/persistence/compare-card/compare-card-localstorage';
import { getPageCardsData, getPageData } from 'src/universal/redux/page';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import {
  getPznOfferList,
  hasPznDataArrived as getHasPznDataArrived
} from 'src/universal/redux/pznData';

// Action Types
const ADD_CARD = 'ADD_CARD';
const ADD_CARDS = 'ADD_CARDS';
const REMOVE_CARD = 'REMOVE_CARD';
const PRESELECTED_CARDS_ARRIVED = 'PRESELECTED_CARDS_ARRIVED';

// Default State
const defaultState = {
  cards: [],
  initialCardsSet: false
};

export const selectedCompareCardsReducer = reducerGenerator(defaultState, {
  [PRESELECTED_CARDS_ARRIVED]: (state, action) => {
    const { preselectedCards } = action;
    if (Array.isArray(preselectedCards) && preselectedCards.length > 0) {
      compareCardLocalstorage.selected.set(preselectedCards);
      compareCardLocalstorage.activity.set(true);
    }
    const selectedCardsInLocalStorage = compareCardLocalstorage.selected.get();
    return {
      ...state,
      cards: selectedCardsInLocalStorage.filter(
        card => card !== null && card !== 'lowes-business-rewards'
      ),
      initialCardsSet: true
    };
  },
  [ADD_CARD]: (state, action) => {
    const cardToBeAdded = get(action, 'shortName');
    const numberOfSelectedCards = state.cards.filter(card => card !== null).length;
    if (numberOfSelectedCards === 3 || !cardToBeAdded) {
      return state;
    } else {
      const newSelectedCardsState = [...state.cards, cardToBeAdded];
      compareCardLocalstorage.selected.set(newSelectedCardsState);
      compareCardLocalstorage.activity.set(true);
      return {
        ...state,
        cards: newSelectedCardsState
      };
    }
  },
  [ADD_CARDS]: (state, action) => {
    const cardsToBeAdded = action?.shortNames || [];
    compareCardLocalstorage.selected.set(cardsToBeAdded);
    compareCardLocalstorage.activity.set(true);
    return {
      ...state,
      cards: cardsToBeAdded
    };
  },
  [REMOVE_CARD]: (state, action) => {
    const cardToBeRemovedShortName = get(action, 'shortName') || '';
    const newSelectedCardsState = state.cards.filter(
      shortName => shortName !== cardToBeRemovedShortName
    );
    compareCardLocalstorage.selected.set(newSelectedCardsState);
    compareCardLocalstorage.activity.set(true);
    return {
      ...state,
      cards: newSelectedCardsState
    };
  }
});

// Dispatches
export const dispatchAddCardToCompare = (dispatch, payload) => {
  dispatch(action(ADD_CARD, payload));
};

export const dispatchAddCardsToCompare = (dispatch, payload) => {
  dispatch(action(ADD_CARDS, payload));
};

export const dispatchRemoveCardFromCompare = (dispatch, payload) => {
  dispatch(action(REMOVE_CARD, payload));
};

export const dispatchPreselectedCardsArrived = (dispatch, payload) => {
  dispatch(action(PRESELECTED_CARDS_ARRIVED, payload));
};

// Selectors
export const getSelectedCompareCards = state =>
  state?.selectedCompareCards?.cards ?? [];

export const getInitialCardsSet = state =>
  state?.selectedCompareCards?.initialCardsSet ?? false;

export const getFilteredSelectedCards = createSelector(
  [getSelectedCompareCards, getPznOfferList, getHasPznDataArrived],
  (selectedCards, offerList, hasPznDataArrived) => {
    if (!hasPznDataArrived) return selectedCards;
    return selectedCards.filter(cardName => {
      return !!offerList.find(offer => offer.shortName === cardName);
    });
  }
);

export const getCardListData = createSelector(
  [getFilteredSelectedCards, getPageCardsData],
  (selectedCards, cardsData) => {
    const allThreeCards = [...selectedCards];
    while (allThreeCards.length < 3) {
      allThreeCards.push(null);
    }
    const cardObj = parseArrayToObject(cardsData, 'shortName');
    return allThreeCards.map(card => cardObj[card]);
  }
);

export const getCardSelectorData = createSelector([getPageData], pageData => {
  const selectorData = pageData.cardSelector || {};
  const ctaList = selectorData?.buttons || [];
  const ctaBack = ctaList.find(cta => cta.key === 'backButton');
  const ctaCompare = ctaList.find(cta => cta.key === 'compareButton');
  const ctaItem = ctaList.find(cta => cta.key === 'cardItem');

  return {
    title: selectorData.title,
    ctaBackText: ctaBack?.text,
    ctaBackDtm: ctaBack?.dtm,
    ctaCompareText: ctaCompare?.text,
    ctaCompareDtm: ctaCompare?.dtm,
    ctaCompareUrl: ctaCompare?.url,
    cardItemDtm: ctaItem?.dtm
  };
});
